import React from "react";
import "./TestOpenQuestion.scss";

const TestOpenQuestion = ({className, testQuestion, question, onChange, answer}) => {
    const questionParts = question.split("%s");

    const handleInputChange = e => {
        let index = e.target.name.split("-")[1];
        const newAnswer = {...answer, [index]: e.target.value};
        onChange(testQuestion._id, newAnswer);
    };

    const renderQuestionAndInputs = () => {
        let elements = [];
        questionParts.forEach((part, index) => {
            elements.push(<h3 key={`question-${testQuestion._id}-${index}`}>{part}</h3>);
            if (index !== questionParts.length - 1) {
                elements.push(
                    <>&nbsp;
                        <input
                            key={`input-${testQuestion._id}-${index}`}
                            type="text"
                            name={`${testQuestion._id}-${index}`}
                            defaultValue={answer?.[index] || ''}
                            onChange={handleInputChange}
                        />
                    </>
                );
            }
        });
        return React.Children.toArray(elements);
    };

    return (
        <div className={`TestOpenQuestion ${className}`}>
            {testQuestion.instructions && <label className="instructions">{testQuestion.instructions}</label>}
            <div className="question">
                {renderQuestionAndInputs()}
            </div>
        </div>
    );
};

export default TestOpenQuestion;
